import { Controller } from "@hotwired/stimulus";

export default class TurnstileController extends Controller {
  static values = {
    sitekey: String,
  };

  connect() {
    this.renderWidget();
  }

  disconnect() {
    this.removeWidget();
  }

  renderWidget() {
    if (typeof turnstile === "undefined") {
      // Turnstile library not loaded yet, wait and retry
      setTimeout(() => this.renderWidget(), 100);
      return;
    }

    // Remove any existing widget first
    this.removeWidget();

    // Render the Turnstile widget explicitly
    this.widgetId = turnstile.render(this.element, {
      sitekey: this.sitekeyValue,
    });
  }

  removeWidget() {
    if (this.widgetId && typeof turnstile !== "undefined") {
      turnstile.remove(this.widgetId);
      this.widgetId = null;
    }
  }
}
